var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserRectangle = function SvgIconUserRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.062 20.5h2.188A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 5.25v13.5c0 .966.784 1.75 1.75 1.75h14.312M4 5.5v13h1.362a7.75 7.75 0 0 1 3.388-3.036 4.75 4.75 0 1 1 6.5 0 7.75 7.75 0 0 1 3.388 3.036H20v-13zm12.131 13a5.76 5.76 0 0 0-4.182-1.75 5.75 5.75 0 0 0-4.08 1.75zm-4.086-3.75a2.75 2.75 0 1 0-.09 0h.09",
    clipRule: "evenodd"
  })));
};
export default SvgIconUserRectangle;